module.exports = __webpack_public_path__ + "static/media/Mama Rochel - Infant Feeding Agreement.689644de.pdf";